import React from 'react';

export interface ContextValue {
  /**
   *
   * Node currently selected
   */
  selectedNodeIds: string[];

  /**
   *
   * Node being dragged
   */
  draggedNodeIds: string[];

  /**
   *
   * Available dropzones for a dragged node
   */
  dropZones: Record<string, { canDropIn: true | string; canDropAfter: true | string } | undefined>;

  /**
   *
   * dropzones becoming interactive on arriving in a droptarget area
   * activated by dragenter
   */
  hoveredDropZones: Record<string, { showDropIn?: boolean; showDropAfter?: boolean } | undefined>;

  /**
   *
   * nodeId affected by the drop action, activated by dragenter
   */
  targetedDropZone: string | null;

  /**
   *
   * callback on starting drag gesture
   */
  handleDragStart?: (event: React.DragEvent<HTMLDivElement> & DragEvent) => void;

  /**
   *
   * callback on focusing a nodelayer item
   */
  handleFocus?: (event: React.FocusEvent) => void;
}
export const LayerContext = React.createContext<ContextValue>({
  selectedNodeIds: [],
  draggedNodeIds: [],
  targetedDropZone: null,
  dropZones: {},
  hoveredDropZones: {},
});
